import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FormOutboundEmailAccountComponent } from '../../../components/forms/form-outbound-email-account/form-outbound-email-account.component';
import { CustomersService } from '../../../_services/customers/customers.service';

@Component({
  selector: 'app-admin-global-email-account',
  standalone: true,
  imports: [CommonModule, TranslateModule, FormOutboundEmailAccountComponent],
  template: `
    <app-form-outbound-email-account
      [scope]="'global'"
      titleKey="ADMIN.EMAIL_ACCOUNTS.GLOBAL_TITLE"
      descriptionKey="ADMIN.EMAIL_ACCOUNTS.GLOBAL_DESCRIPTION"
      [loadFn]="loadFn"
      [saveFn]="saveFn"
      [testFn]="testFn"
    ></app-form-outbound-email-account>
  `,
})
export class AdminGlobalEmailAccountComponent {
  constructor(private readonly customersService: CustomersService) {}

  readonly loadFn = () => this.customersService.getGlobalEmailAccount();
  readonly saveFn = (payload: any) => this.customersService.updateGlobalEmailAccount(payload);
  readonly testFn = (to?: string) => this.customersService.testGlobalEmailAccount(to);
}
